import { IPage, ISearchPage, ISearchPageField } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface ILplDetail {
    id: string;
    code: string;
    carryTime?: string // "2022-04-21"
    clearTime?: string // "2022-04-21"
    consignmentTime?: string // "2022-04-21"
    inDeliveryTime?: string // "2022-04-21"
    inquiryCode?: string // "X-GFG-2224"
    ladingTime?: string // "2022-04-21"
    offerCode?: string // "B-GFG-2223,B-GFG-2224,B-GFG-2225"
    presentationTime?: string // "2022-04-21"
    purchaseCode?: string // "BJOH-YHCY-2224"
    releaseTime?: string // "2022-04-21"
    shipmentTime?: string // "2022-04-21"
    shippingTime?: string // "2022-04-21"
    [key: string]: any
}

//新增
export interface ILplInsert extends ILplDetail { }

//编辑
export interface ILplUpdate extends ILplInsert {
    id: string;
}

//搜索条件
export interface ILplSearchFields {
    shopCode?: string,
    code?: string,
    startTime?: string,
    endTime?: string,
}

export interface ILplSearch extends ILplSearchFields, ISearchPage { }

export interface ILplAuditDetail {
    key: any;
    auditLevel?: string,  // "财务"
    auditProject?: string,  // "外贸合同"
    auditUser?: string,  // "庞愿领"
    code?: string,  // "YYCY-motuo-2202"
    createTime?: moment.Moment |string |null,  // "2022-05-13T10:48:42"
    createUser?: string,  // "庞愿领"
    deleteFlag?: string,  // 0
    id?: string,  // "8cf4c654fac785705892bfd4301ddf59"
    note?: string,  // "222"
    status?: string,  // 0
    submitUser?: string,  // "庞愿领"
    updateTime?: moment.Moment |string |null,  // "2022-05-13T10:48:41"
}
export interface ILplAuditSearch extends ILplSearchFields, ISearchPage, ISearchPageField { }



class LplService {
    async page(searchVo: ILplSearch, config: object = {}) {
        const apiUrl = "/gtm/standingBooking/listPage";
        return await httpRequest.post<IPage<ILplDetail>>(apiUrl, searchVo, config);
    }
    async auditPage(searchVo: ILplAuditSearch, config: object = {}) {
        const apiUrl = "/gtm//audit/search/pg";
        return await httpRequest.post<IPage<ILplAuditDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: ILplSearch) {
        const appPageUrl = "/gtm/standingBooking/listPage/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/sale/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

}

export const lplService = new LplService();
